'use client';

import { useMemo } from 'react';
import { useRegionLocale } from 'contexts/RegionLocaleContext';

// Regions that see C&O Pro. Matches the regions FAQ, except Antigua and
// Barbuda (AG), which is listed there but not enabled yet.
export const CNO_PRO_COUNTRIES = new Set([
  'US', // United States
  'GB', // United Kingdom
  'CA', // Canada
  'AU', // Australia
  'BS', // Bahamas
  'IM', // Isle of Man
]);

// CNO_PRO_COUNTRIES is the CnOPro allowlist; every other region — including an
// unknown/empty one — is CnOPlus. `getValue(pro, plus)` takes the CnOPro value
// FIRST; the argument order is easy to invert.
export const useIsCnOPlus = () => {
  const { region: country } = useRegionLocale();

  const isCnOPlus = useMemo(() => {
    const countryCode = (country || '').toUpperCase();

    if (!countryCode) {
      return true;
    }

    return !CNO_PRO_COUNTRIES.has(countryCode);
  }, [country]);

  const getValue = useMemo(
    () =>
      <T,>(defaultValue: T, switchValue: T): T => {
        return isCnOPlus ? switchValue : defaultValue;
      },
    [isCnOPlus]
  );

  return { isCnOPlus, getValue };
};

export default useIsCnOPlus;

